if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
            const variant = data.variant
            if (variant.available) {
              this.submitButton.removeAttribute('aria-disabled');
            }
        })
      }

      get form() {
        return this.querySelector('form');
      }

      get submitButton() {
        return this.querySelector('[type="submit"]')
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') 
          return;

        if (this.submitButton.dataset.type === 'notify-me') {
          publish(PUB_SUB_EVENTS.notifyMe, {form: this.form});
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = { items: [], sections_url: window.location.pathname, sections: this.cart.getSectionsToRender().map((section) => section.id) };

        this.querySelectorAll('.product-variant-id')
            .forEach((input) => {
                  input.value
                  && formData.items.push({
                          id: input.value,
                          quantity: 1,
                          properties: {}
                      })
            });

        const propertyInputs =
            this.querySelectorAll('[name^="properties"]');

          propertyInputs?.forEach(input => {
            formData.items.forEach(item => {
                if (!input?.value) return
                const match = input.name.match(/\[(.*?)\]/);
                const extracted = match ? match[1] : null;
                item.properties[extracted] = input.value
            })
          });

        config.body = JSON.stringify(formData);
        config.headers = {
          'Content-Type': 'application/json',
          ...config.headers
        };
        
        const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
        const response = await fetchResponse.json()

        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.items[0]?.id,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.querySelector('.loading__spinner').classList.add('hidden');

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
              productVariantId: formData.items[0]?.id,
                cartData: response,
            });

            const trackingProduct = this.querySelector('[data-tracking-product]');
            if (trackingProduct) {
              publish(PUB_SUB_EVENTS.onGenericTrackEvent, {
                events: [['track', 'Added to Cart', JSON.parse(trackingProduct.innerHTML)]]
              });
            }
        }
        this.error = false;
        this.cart.onCartUpdate ? this.cart.onCartUpdate() : this.cart.renderContents(response);
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        if (window.template.name === 'cart') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButton.classList.toggle('not-active', disable)
        this.submitButton.toggleAttribute('disabled', disable);

        const textContent = !disable ? window.variantStrings.addToCart : (!text ? this.submitButtonText.textContent : text);
        this.submitButtonText.textContent = textContent;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
